
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_1rpnh_93",
  "marker": "awsui_marker_10ipo_1rpnh_144",
  "marker--line": "awsui_marker--line_10ipo_1rpnh_187",
  "marker--rectangle": "awsui_marker--rectangle_10ipo_1rpnh_191",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_10ipo_1rpnh_198",
  "marker--dashed": "awsui_marker--dashed_10ipo_1rpnh_214",
  "root": "awsui_root_10ipo_1rpnh_237",
  "value": "awsui_value_10ipo_1rpnh_272",
  "expandable": "awsui_expandable_10ipo_1rpnh_276",
  "list-item": "awsui_list-item_10ipo_1rpnh_280",
  "inner-list-item": "awsui_inner-list-item_10ipo_1rpnh_281",
  "key-value-pair": "awsui_key-value-pair_10ipo_1rpnh_286",
  "expandable-section": "awsui_expandable-section_10ipo_1rpnh_287",
  "key": "awsui_key_10ipo_1rpnh_286",
  "sub-items": "awsui_sub-items_10ipo_1rpnh_300",
  "list": "awsui_list_10ipo_1rpnh_280",
  "compact": "awsui_compact_10ipo_1rpnh_326",
  "with-sub-items": "awsui_with-sub-items_10ipo_1rpnh_331",
  "full-width": "awsui_full-width_10ipo_1rpnh_336",
  "announced": "awsui_announced_10ipo_1rpnh_340"
};
  